<script>
export default {
  name: "SocialMediaItemCard",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    headerPicture() {
      if (this.item.Facebook.length === 0) return undefined;

      return process.env.VUE_APP_API_BASE_URL + this.item.Facebook[0].url;
    },
    tags() {
      const badges = [];

      if (this.item.Facebook.length > 0) badges.push('Facebook');
      if (this.item.Instagram.length > 0) badges.push('Instagram');
      if (this.item.LinkedIn.length > 0) badges.push('LinkedIn');
      if (this.item.Stories.length > 0) badges.push('Stories');

      return badges;
    },
    detailsUrl() {
      return `/social-media-campaign/${this.item.id}`;
    }
  }
}
</script>

<template>
<v-card class="social-media-item-card">
  <v-img :src="headerPicture" class="white--text align-end header-img">
  <v-card-title v-text="item.Name"/>
  </v-img>
  <v-card-text>
    <div>
      <span v-for="tag in tags" :key="tag" class="tag mr-2 px-2">{{ tag }}</span>
    </div>
    <p>{{ item.Beschreibung }}</p>
  </v-card-text>
  <v-card-actions class="pb-3">
    <v-btn color="primary" class="px-10" :to="detailsUrl">
      <v-icon left>mdi-arrow-right-thin</v-icon>
      Details</v-btn>
  </v-card-actions>
</v-card>
</template>

<style scoped>
.social-media-item-card {
  border-radius: 5px !important;
}

.header-img {
  border-radius: 0 !important;
}

.tag {
  background: #B400551A;
  color: #B40055;
  letter-spacing: 0.6px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 17px;
  padding-top: 3px;
  padding-bottom: 2px;
}
</style>
